<template>
  <filter-bar>
    <div class="md-size-33 md-layout-item md-size-25 md-xsmall-size-100">
      <div class="outlined-field">
        <md-field>
          <label>Proveedores</label>
          <md-select :disabled="loading" v-model="payload.provider">
            <md-option
              v-for="provider in catalogs.providers"
              :key="provider.id"
              :value="provider.id"
            >{{ provider.name }}</md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <div class="md-layout-item md-size-25 md-xsmall-size-100">
      <div class="outlined-field">
        <md-field>
          <label>Buscar por RM</label>
          <md-input :disabled="loading" v-model="payload.searchQuery"></md-input>
        </md-field>
      </div>
    </div>
    <div class="md-layout-item md-size-25 md-xsmall-size-100">
      <md-field>
        <label for="dateFrom">
          <md-icon>calendar_today</md-icon>
          <span v-show="!payload.dateFrom">Desde</span>
        </label>
        <datetime
          :disabled="loading"
          input-style="border: none; outline:none; width: 100%"
          :max-datetime="payload.dateTo"
          type="date"
          title="Desde"
          value-zone="America/Mexico_City"
          v-model="payload.dateFrom"
          :phrases="{ ok: '', cancel: '' }"
          auto
        ></datetime>
        <md-button class="md-simple md-just-icon" @click="payload.dateFrom = null">
          <md-icon>close</md-icon>
        </md-button>
      </md-field>
    </div>

    <div class="md-layout-item md-size-25 md-xsmall-size-100">
      <md-field>
        <label for="dateOccurred">
          <md-icon>calendar_today</md-icon>
          {{ payload.dateTo ? "" : "Hasta" }}
        </label>
        <datetime
          :disabled="loading"
          :max-datetime="today"
          :min-datetime="payload.dateFrom"
          input-style="border: none; outline:none; width: 100%"
          type="date"
          title="Hasta"
          value-zone="America/Mexico_City"
          v-model="payload.dateTo"
          :phrases="{ ok: '', cancel: '' }"
          auto
        ></datetime>
        <md-button class="md-simple md-just-icon" @click="payload.dateTo = null">
          <md-icon>close</md-icon>
        </md-button>
      </md-field>
    </div>
  </filter-bar>
</template>

<script>
// COMPONENT
import FilterBar from "@/components/FilterBar";

// UTILS
import { cloneDeep } from "lodash";
import providesValidatorMixin from "@/mixins/providesValidator";

export default {
  name: "CompleteDataFilters",
  components: {
    FilterBar,
  },
  props: {
    catalogs: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      today: new Date(Date.now()).toISOString(),
      payload: {},
    };
  },
  mixins: [providesValidatorMixin],
  watch: {
    payload: {
      deep: true,
      handler(newVal) {
        this.$emit("input", newVal);
      },
    },
  },
  mounted() {
    this.payload = cloneDeep(this.value);
  },
};
</script>

<style lang="scss" scoped>
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}

.vdatetime {
  margin-left: 2em;
  margin-top: 1.1em;
  width: 100%;
}

.before-list-item {
  font-size: 1.6rem;
  padding: 8px 0px 8px 10px;
}
.before-list-item:hover {
  cursor: pointer !important;
  background-color: red;
  font-weight: bold;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/pages/Providers/AccountReport/Filter.vue